import { elakay_API } from "../../config";
import { decryptData } from "./elakayCryptage";
import { isAuthenticated } from "./index";

const decodeResponse = async (data) => {
  if (data?.ciphertext && data?.iv && data?.salt && data?.tag) {
    return decryptData(data);
  }
  return data;
};

const request = async (path, options = {}) => {
  const response = await fetch(`${elakay_API}${path}`, {
    ...options,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ...(options.headers || {}),
    },
  });
  const raw = await response.json();
  const data = await decodeResponse(raw);
  if (!response.ok) throw new Error(data?.error || `Erreur ${response.status}`);
  return data;
};

export const getUserAbout = (userID) =>
  request(`/user/about/${encodeURIComponent(userID)}`);

export const saveUserAbout = (page, token = isAuthenticated()?.token) =>
  request("/user/about", {
    method: "PUT",
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    body: JSON.stringify({ page }),
  });
